import { CheckNotes, InspectionCase } from '../inspection-cases';

export class PaSystemDto extends InspectionCase {
  item_11_1?: InspectionCase;
  item_11_2?: InspectionCase;
  item_11_3?: InspectionCase;
  item_11_4?: InspectionCase;
  item_11_5?: InspectionCase;
  item_11_6?: InspectionCase;
}

export class PaSystem extends PaSystemDto {
  constructor(data: PaSystemDto = { title: 'כריזה' }) {
    super(data);
    this.item_11_1 = new InspectionCase({
      ...data.item_11_1,
      title: `שומעים את ההודעה בכל מקום באתר`
    });
    this.item_11_2 = new InspectionCase({
      ...data.item_11_2,
      title: `מערכת הכריזה מותקנת בהתאם לסעיף 11.1.5 של ת"י 1220 חלק 3`
    });
    this.item_11_3 = new InspectionCase({
      ...data.item_11_3,
      title: `הותקנה מערכת כריזה מאושרת לפי ת"י 1220 חלק 2`
    });
    this.item_11_4 = new InspectionCase({
      ...data.item_11_4,
      title: `נשמעים שלושה "גונגים" לפני הכריזה`
    });
    this.item_11_5 = new InspectionCase({
      ...data.item_11_5,
      title: `קווי הרמקולים מבוקרים כנגד נתק . כמו כן קו דיווח תקלה מהכריזה לרכזת וקו דיווח תקלה מהכריזה לרכזת וקו ההפעלה של הכריזה מהרכזת מבוקר כנגד נתק`
    });
    this.item_11_6 = new InspectionCase({
      ...data.item_11_6,
      title: `מערכת הכריזה המותקנת נבדקה לפי ת"י 1220 חלק 2`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.item_11_1.isApplicable || this.item_11_1.isPassed) &&
        (!this.item_11_2.isApplicable || this.item_11_2.isPassed) &&
        (!this.item_11_3.isApplicable || this.item_11_3.isPassed) &&
        (!this.item_11_4.isApplicable || this.item_11_4.isPassed) &&
        (!this.item_11_5.isApplicable || this.item_11_5.isPassed) &&
        (!this.item_11_6.isApplicable || this.item_11_6.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.item_11_1.getNotes(),
      ...this.item_11_2.getNotes(),
      ...this.item_11_3.getNotes(),
      ...this.item_11_4.getNotes(),
      ...this.item_11_5.getNotes(),
      ...this.item_11_6.getNotes()
    ];
  }
}
